import { useCallback } from 'react';
import { unwrapResult } from '@reduxjs/toolkit';
import { GenerateCategoryDescriptionRequestDto } from '@tiendanube/common';
import { useAppDispatch } from 'App/store';
import { generateCategoryDescription } from '../../categoriesSlice';

function useGenerateCategoryDescription() {
  const dispatch = useAppDispatch();

  const generateDescription = useCallback(
    async (requestDto: GenerateCategoryDescriptionRequestDto) => {
      const result = await dispatch(generateCategoryDescription(requestDto));
      return unwrapResult(result);
    },
    [dispatch],
  );

  return { generateDescription };
}

export default useGenerateCategoryDescription;
